import React from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteFreshmenReadmission = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const { oid, name } = props.data

  const handleOk = () => {
    axios.post('/p/retention_admission/application/delete', { 
      merchant_oid: merchantOid, 
      retention_admission_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('删除保留入学资格学生复学申请成功！')
          props.isCancel()
          props.getApplicationData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="删除保留入学资格学生复学申请"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将
        <span style={{color: '#005dff'}}>《{name}》</span>
        的保留入学资格学生复学申请从列表中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteFreshmenReadmission
